import { toast } from "react-toastify";

let headerProvider: () => Record<string, string> = () => ({});

export function setHeaderProvider(fn: () => Record<string, string>) {
    headerProvider = fn;
}

export async function fetcher<T>({input, init, onStatus, mapToastMsg, errorMessage}: {
    input: RequestInfo
    init?: RequestInit
    onStatus?: (status: number) => void
    mapToastMsg?: (msg: string) => string
    errorMessage?: string
}
): Promise<T> {
    const headers = {
        'Content-Type': 'application/json',
        ...headerProvider(),
        ...(init?.headers || {}),
    };

    const response = await fetch(input, { ...init, headers });

    if (!response.ok) {
        onStatus?.(response.status);

        const defaultMessage = getFriendlyStatusMessage(response.status);
        const error = new Error(defaultMessage);
        (error as any).status = response.status;

        const message = errorMessage || defaultMessage;
        toast.error(mapToastMsg ? mapToastMsg(message) : message);
        
        throw error; // Важно: выбрасываем ошибку для React Query
    }

    try {
        return await response.json();
    } catch (parseError) {
        const error = new Error(`Failed to parse response as JSON: ${parseError}`);
        (error as any).status = response.status;
        throw error;
    }
}

function getFriendlyStatusMessage(status: number): string {
    switch (status) {
        case 400:
            return 'Проверьте введенные данные и попробуйте еще раз.';
        case 401:
            return 'Сессия истекла. Попробуйте войти снова.';
        case 403:
            return 'У вас нет доступа к этому действию.';
        case 404:
            return 'Запрашиваемые данные не найдены.';
        case 429:
            return 'Слишком много запросов. Попробуйте немного позже.';
        case 500:
        case 502:
        case 503:
            return 'Сервис временно недоступен. Попробуйте позже.';
        case 504:
            return 'Сервер не отвечает. Попробуйте позже.';
        default:
            return 'Не удалось выполнить запрос. Попробуйте еще раз.';
    }
}